import { ITicketProductWithBundleType } from '@nx-ng/types';
import { KnownPricePaymentMethod, Price } from '@modules/ticket-fares-store';
import { BasketItem } from '../../client/src';
import { CreateBasketItem } from '@modules/checkout-store/types';

export const formatBasketItemForAPI = (
  item: CreateBasketItem,
  allTickets: ITicketProductWithBundleType[] = []
): BasketItem | undefined => {
  const findTicketDetails = allTickets.find(
    (ticket: ITicketProductWithBundleType) => ticket.id === item.ticketID
  );
  if (!findTicketDetails) {
    return undefined;
  }

  const price = determinePrice(findTicketDetails.price);
  const toPayPrice = price; // TODO: To be implemented when we have discount codes. To pay it total price of item - discount

  return {
    ticketID: item.ticketID,
    quantity: item.quantity,
    itemPrice: price,
    price: price,
    toPayPrice,
    subTotalPrice: price, // NOTE: This should be the same as price - it takes over from the old "price"
    paymentMethodType: KnownPricePaymentMethod.OneOff,
  };
};

export const determinePrice = (prices: Price[] | undefined): number => {
  let findPrice: Price | undefined = undefined;

  findPrice = prices?.find(
    (price) => price.paymentMethod === KnownPricePaymentMethod.OneOff
  );

  return findPrice?.price ?? 0;
};
